import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import './CourseDetails.css';
import { toast } from 'react-toastify';
import CourseDetailsContent from './CourseDetailsContent';
import VideoModal from './VideoModal';
import { useDispatch } from 'react-redux';
import { clearEnrollments, enrollCourse } from '../../ReduxStore/EnrollSlice';
import { addToReduxCart } from '../../ReduxStore/CartSlice';
import { addToCart, COURSES_URL, ENROLLMENT_URL } from '../../Services/courseService';
import ClipLoader from 'react-spinners/ClipLoader';
import CourseTabs from './CourseTabs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from 'react-helmet';

const CourseDetails = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const courseDropdownRef = useRef(null);
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEnrolled, setIsEnrolled] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch();
  const [btnClicked, setBtnClicked] = useState(false);
  const [AddToCartLoading, setAddToCartLoading] = useState(false);
  const [avgRating, setAvgRating] = useState(4.2);
  const userId = localStorage.getItem('userId');

  const [metaTitle, setMetaTitle] = useState('SkillzVerse – Online Courses');
  const [metaDescription, setMetaDescription] = useState(
    'Explore high-quality online courses with SkillzVerse. Join to learn top tech skills from industry experts.'
  );
const [metaKeywords, setMetaKeywords] = useState(
    'Online Courses, Programming Courses, SkillzVerse'
);
const [courseH1, setCourseH1] = useState('');

  useEffect(() => {
    const fetchCourseBySlug = async () => {
      try {
        const response = await axios.get(`${COURSES_URL}/course`);
        const allCourses = response.data?.data || [];

       const generateSlug = (title) =>
    title
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');

const matchedCourse = allCourses.find(
    course => generateSlug(course.title) === slug
);
    

        if (!matchedCourse) {
          toast.error("Course not found");
          setLoading(false);
          return;
        }

        const courseId = matchedCourse.courseId;

        const [courseRes, ratingRes] = await Promise.all([
          axios.get(`${COURSES_URL}/course/${courseId}`),
          axios.get(`${COURSES_URL}/course/${courseId}/average-rating`)
        ]);

        setCourse(courseRes.data);
        setAvgRating(ratingRes.data?.data || 4);

        if (userId) {
          try {
            const enrollmentRes = await axios.get(`${ENROLLMENT_URL}/${userId}/${courseId}/getEnrollmentStatus`);
            setIsEnrolled(enrollmentRes?.data);
          } catch (err) {
            if (err?.response?.status !== 400) {
              console.error("Unexpected error checking enrollment:", err);
            }
            setIsEnrolled(false);
          }
        }

      } catch (err) {
        console.error("Error loading course details:", err);
        toast.error("Error loading course details");
      } finally {
        setLoading(false);
      }
    };

    fetchCourseBySlug();
  }, [slug, userId]);

  useEffect(() => {
    if (!course?.data?.title) return;

    const title = course.data.title.toLowerCase();
    const seoMap = [
      {
        keywords: ['core java'],
        metaTitle: 'Core Java Programming Course | SkillzVerse',
        metaDescription: 'Enroll in the Core Java Programming Course at SkillzVerse to master Java fundamentals, OOP concepts, hands-on coding, and practical projects with expert training.',
      metaKeywords: 'Core Java Programming Course,Core Java Course,Learn Core Java,Java Programming Course,Java Training,Online Java Course',
      h1: 'Core Java Programming Course for Beginners and Professionals'
    },
      {
        keywords: ['e-home'],
        metaTitle: 'Java React Spring Boot Project | SkillzVerse',
        metaDescription: 'Build a Java React Spring Boot project at SkillzVerse with hands-on training, real-world development, expert guidance, and practical full stack development skills.',
            metaKeywords: 'Java React Spring Boot Project,Java Full Stack Project,Spring Boot Project,React Project,Full Stack Java Course,Java Spring Boot Training,React Development Course,Full Stack Web Development,Real-Time Java Project,Java Backend Development,Project-Based Learning',
         h1: 'Java React Spring Boot Full Stack Project Course'
          },
      {
        keywords: ['frontend'],
        metaTitle: 'Frontend Web Development Course | SkillzVerse',
        metaDescription: 'Enroll in the Frontend Web Development Course at SkillzVerse to master HTML, CSS, JavaScript, responsive design, and practical projects with expert-led training.',
      metaKeywords:'Frontend Web Development Course, HTML CSS JavaScript Course,Frontend Development Training,Learn Frontend Development,Online Frontend Course,JavaScript Course,Responsive Web Design,Web Development Course,Frontend Developer Training',
       h1: 'Frontend Web Development Course with HTML, CSS & JavaScript'
    },
      {
        keywords: ['backend'],
        metaTitle: 'Backend Development with Java | SkillzVerse',
        metaDescription: 'Enroll in the Backend Development with Java course at SkillzVerse to master Spring Boot, REST APIs, databases, hands-on projects, and job-ready backend skills.',
      metaKeywords:'Backend Development with Java,Java Backend Course,Java Backend Development,Spring Boot Course,Java REST API Course,Java Developer Course',
      h1: 'Backend Development with Java Course for Job-Ready Developers'
    },
      {
        keywords: ['spring boot'],
        metaTitle: 'Spring & Spring Boot Course | SkillzVerse',
        metaDescription: 'Enroll in the Spring and Spring Boot Development Course at SkillzVerse to master Spring Framework, REST APIs, microservices, hands-on projects, and job-ready Java skills.',
      metaKeywords:'Spring and Spring Boot Development Course,Spring Boot Course,Spring Framework Course,Learn Spring Boot,Spring Boot Training,Java Spring Boot Course',
      h1: 'Spring and Spring Boot Development Course for Java Developers' 
    },
      {
        keywords: ['java'],
        metaTitle: 'Java Full Stack Development Course | SkillzVerse',
        metaDescription: 'Enroll in the Java Full Stack Development Course at SkillzVerse to master Java, Spring Boot, React, REST APIs, real-world projects, and job-ready development skills.',
     metaKeywords:'Java Full Stack Development Course,Java Full Stack Course,Full Stack Java Course,Java Full Stack Training,Learn Java Full Stack,Java Full Stack Developer Course',
      h1: 'Java Full Stack Development Course for Job-Ready Developers'
    },
      {
        keywords: ['python'],
        metaTitle: 'Python Programming Course | SkillzVerse',
        metaDescription: 'Enroll in the Python Programming Course at SkillzVerse to learn Python through expert-led training, hands-on projects, practical coding, and job-ready skills.',
       metaKeywords:'Python Programming Course,Learn Python Online,Python Course,Python Training,Python Programming Training,Python Coding Course',
       h1: 'Python Programming Course for Beginners and Professionals'
      },
      {
        keywords: ['machine learning'],
        metaTitle: 'Machine Learning Course | SkillzVerse',
        metaDescription: 'Enroll in the Machine Learning Course at SkillzVerse to learn ML algorithms, predictive models, hands-on projects, and practical AI skills with expert-led training.',
      metaKeywords:'Machine Learning Course,Machine Learning Training,Learn Machine Learning,Machine Learning for Beginners,Online Machine Learning Course,AI and Machine Learning Course',
       h1: 'Machine Learning Course for Beginners and Professionals'
    },
    {
  keywords: ['cyber security ethical hacking project'],
  metaTitle: 'Cyber Security Ethical Hacking Project Course | SkillzVerse',
  metaDescription:
    'Enroll in the Cyber Security Ethical Hacking Project Course at SkillzVerse to gain practical experience in ethical hacking, penetration testing, network security, and real-world cybersecurity projects.',
  metaKeywords:
    'Cyber Security Ethical Hacking Project,Ethical Hacking Course,Cyber Security Course,Penetration Testing Course,Learn Ethical Hacking,Cyber Security Training',
  h1: 'Cyber Security Ethical Hacking Project Course'
},
      {
    keywords: ['cyber security'],
metaTitle: 'Certified Penetration Tester Course | SkillzVerse',
metaDescription:'Enroll in the Certified Penetration Tester Course at SkillzVerse to master ethical hacking, VAPT, network security, hands-on labs, and job-ready cybersecurity skills.',
 metaKeywords:
        'Certified Penetration Tester Course,Penetration Testing Course,Ethical Hacking Course,Cyber Security Course,Certified Ethical Hacker Training,Vulnerability Assessment and Penetration Testing (VAPT) Course',
h1: 'Certified Penetration Tester (CPT) Course for Cybersecurity Professionals'
      },
{
    keywords: ['aws solution architect associate'],
metaTitle: 'AWS Solution Architect Course | SkillzVerse',
metaDescription:
        'Enroll in the AWS Solution Architect Associate Course at SkillzVerse to master AWS cloud services, architecture, hands-on labs, and job-ready cloud computing skills.',
metaKeywords:

'AWS Solution Architect Associate Course,AWS Solution Architect Course,AWS Certification Course,AWS Cloud Training,Learn AWS Cloud,AWS Solutions Architect Associate Certification',
h1: 'AWS Solution Architect Associate Course for Cloud Professionals'
},
     
   
];

    const matched = seoMap.find(({ keywords }) =>
      keywords.some((keyword) => title.includes(keyword))
    );

    if (matched) {
      setMetaTitle(matched.metaTitle);
      setMetaDescription(matched.metaDescription);
       setMetaKeywords(matched.metaKeywords);
        setCourseH1(matched.h1);
    } else {
      setMetaTitle(`${course.data.title} | SkillzVerse`);
      setMetaDescription(
        course.data.description?.slice(0, 160) ||
        'Learn top tech courses online at SkillzVerse with industry experts.'
      );
        setMetaKeywords(
        `${course.data.title}, Online Course, SkillzVerse, Programming Course`
    );
    setCourseH1(course.data.title);
    }
  }, [course]);


  const schemaMarkup = course?.data
    ? {
      "@context": "https://schema.org",
      "@type": "Course",
      "name": course.data.title,
      "description": course.data.description,
      "url": `https://skillzverse.com/courses/${slug}`,
      ...(course.data.certificateAvailable && {
        educationalCredentialAwarded: "Certificate"
      }),
      "learningResourceType": "Online Course",
      "audience": {
        "@type": "Audience",
        "audienceType": "Students, Professionals"
      },
      "isAccessibleForFree": course.data.price === 0,
      "provider": {
        "@type": "Organization",
        "name": "SkillzVerse",
        "url": "https://skillzverse.com"
      },
      "educationalLevel": course.data.level || "Beginner",
      "courseCode": course.data.course_id || "",
      "inLanguage": "en",
      "hasCourseInstance": {
        "@type": "CourseInstance",
        "courseMode": "online",
        ...(course.data.schedule && {
          courseSchedule: {
            "@type": "Schedule",
            name: course.data.schedule,
            repeatFrequency: "P1W", // Weekly ISO duration
            repeatCount: 1
          }
        }),
        "startDate": course.data.startDate || new Date().toISOString().split("T")[0],
        ...(course.data.endDate && { endDate: course.data.endDate }),
        "instructor": {
          "@type": "Person",
          "name": course.data.instructor || "SkillzVerse Instructor"
        },
        "location": {
          "@type": "VirtualLocation",
          "url": `https://skillzverse.com/courses/${slug}`
        }
      },
      "offers": {
        "@type": "Offer",
        "url": `https://skillzverse.com/courses/${slug}`,
        "price": course.data.price?.toString() || "0",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock",
        "validFrom": new Date().toISOString().split("T")[0],
        "category": course.data.category || "Programming"
      },
      "about": {
        "@type": "Thing",
        "name": course.data.category || "Web Development"
      }
    }
    : null;


  const handleEnroll = () => {
    if (localStorage.getItem('token')) {
      dispatch(clearEnrollments());
      dispatch(enrollCourse([{ courseId: course?.data?.courseId, title: course?.data?.title, price: course?.data?.price }]));
      navigate('/checkout');
    } else {
      navigate('/login');
    }
  };

  const handleAddToCart = async () => {
    toast.dismiss();
    if (!userId) return toast.error('Please login to add to cart');
    setAddToCartLoading(true);
    try {
      const res = await addToCart(userId, course?.data?.courseId);
      if (res.status === 201) {
        dispatch(addToReduxCart({ ...course?.data, quantity: 1 }));
        setBtnClicked(true);
        toast.success('Item added to cart!');
      } else {
        toast.error('This item is already in your cart');
      }
    } catch (error) {
      toast.error('This item is already in your cart');
    } finally {
      setAddToCartLoading(false);
    }
  };


  const openVideoModal = () => setModalOpen(true);
  const closeVideoModal = () => setModalOpen(false);
  const formatDate = (date) => new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

  const rating = avgRating?.data || 4;
  const stars = Math.round(rating);
  const imageUrl = course?.data?.imageUrl || 'https://skillzverse.com/default-meta-img.jpg';

  if (loading) return <div className='course-detail-container'><ClipLoader color="#333" size={30} /></div>;
  if (!course) return <div className='course-detail-container'>Course not found</div>;

  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
           <meta
        name="keywords"
        content={metaKeywords}
    />
    

        {/* Open Graph for social sharing */}
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:image" content={imageUrl} />
        <meta property="og:url" content={`https://skillzverse.com/courses/${slug}`} />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metaTitle} />
        <meta name="twitter:description" content={metaDescription} />
        <meta name="twitter:image" content={imageUrl} />

        {/* Canonical URL for SEO */}
        <link rel="canonical" href={`https://skillzverse.com/courses/${slug}`} />

        {/* JSON-LD Structured Data */}
        {schemaMarkup && (
          <script type="application/ld+json">
            {JSON.stringify(schemaMarkup).replace(/<\/script>/g, '<\\/script>')}
          </script>
        )}
      </Helmet>


      <div className="course-detail-container">
        <div className="course-detail-container2">
          <div className="course-detail-card">
            <h1 className="course-detail-title">
    {courseH1 || course?.data?.title}
</h1>
            <p className="course-detail-description">{course?.data?.description}</p>
            <p className="enrolled-detail-count">Price ₹<span className="enrolled-detail-count-price">{course?.data?.price}</span></p>

            <button className="enroll-detail-button" onClick={handleEnroll} disabled={isEnrolled}>
              {isEnrolled ? 'Enrolled' : 'Enroll Now'} <FontAwesomeIcon icon={faUpRightFromSquare} />
            </button>

            {!btnClicked ? (
              <button className="enroll-detail-button" onClick={handleAddToCart}>
                {AddToCartLoading ? 'Loading...' : 'Add to Cart'}
              </button>
            ) : (
              <Link to="/Cart">
                <button className="enroll-detail-button">Go to Cart</button>
              </Link>
            )}

            <p className="enrolled-detail-count">Duration: <span className="enrolled-detail-count-price">{course?.data?.totalDuration}</span></p>
            <p className="enrolled-detail-count">1024 already enrolled</p>
          </div>


          <div className="demoVideo-container">
            <div className="image-wrapper">
              <img
                src={course?.data?.imageUrl}
                alt="video-thumbnail"
                className="demoVideo-img"
                onClick={openVideoModal}
              />
              <button className="play-button" onClick={openVideoModal}>▶</button>
            </div>
          </div>
          {isModalOpen && (
            <VideoModal
              onClose={closeVideoModal}
              refe={courseDropdownRef}
              courseId={course?.data?.courseId}
              courseData={course}
            />
          )}
        </div>

        <div className="course-detail-info">
          <div className="course-detail-module"><strong>{course?.data?.sections?.length} Course modules</strong><p>Earn a career credential</p></div>
          <div className="course-detail-schedule"><strong>Flexible schedule</strong><p>Learn at your own pace</p></div>
          <div className="course-detail-level"><strong>{course?.data?.level}</strong><p>Recommended experience</p></div>
          <div className="course-detail-update"><strong>Created at</strong><p>{formatDate(course?.data?.createdAt)}</p></div>
          <div className="course-detail-rating">
            <strong>{rating} <span className="stars">{'★'.repeat(stars)}{'☆'.repeat(5 - stars)}</span></strong>
            <p>(144 reviews)</p>
          </div>
        </div>

        {course?.data?.price > 5000 && (
          <div className="course-advantages">
            <h2>Why choose this course?</h2>
            <ul>
              <li><FontAwesomeIcon icon={faCheck} /> <strong>Career Support</strong>: Placement assistance.</li>
              <li><FontAwesomeIcon icon={faCheck} /> <strong>Mock Interviews</strong>: Enhance job readiness.</li>
              <li><FontAwesomeIcon icon={faCheck} /> <strong>Internship Guarantee</strong>: Paid/unpaid access.</li>
            </ul>
          </div>
        )}

        <CourseTabs description={course?.data?.description} numOfModules={course?.data?.sections?.length} />
        <div className="course-content-mainContainer">
          <CourseDetailsContent courseData={course} handleEnroll={handleEnroll} />
        </div>
      </div>
    </>
  );
};

export default CourseDetails;
